export default "__VITE_ASSET__BN_4Z8D3__"